import React from 'react';
import { Navbar, NavbarBrand, Nav, NavItem, NavLink } from 'reactstrap';
import { msalConfig, tokenRequest, logoutUrl } from '../../config-client';
import { callApiWithB2CToken } from '../../actions/callApi';

const Msal = require('msal');

const myMSALObj = new Msal.UserAgentApplication(msalConfig);

const styles = {
  patient: {
    margin: 'auto 0 auto auto',
    color: '#0a90bb',
    cursor: 'pointer',
  },
  logout: {
    cursor: 'pointer',
  },
};

function logoutUser() {
  const url = logoutUrl;
  const headers = new Headers();
  headers.append('Accept', 'application/json');
  headers.append('Content-Type', 'application/json');
  myMSALObj.acquireTokenSilent(tokenRequest)
    .then(tokenResponse => callApiWithB2CToken(url, tokenResponse.accessToken, headers, 'GET')
      .then(response => response.json()))
    .then((json) => {
      return myMSALObj.logout();
    })
    .catch(error => (
      <div>
          An error occurred in patienthomenav.js
      </div>
    ));
}

const PatientHomeNav = ({ history }) => (
  <div className="patientinfonav">
    <Navbar light expand="md">
      <NavbarBrand>Welcome</NavbarBrand>
      <NavbarBrand
        style={styles.patient}
        onClick={() => {
          history.push('/PatientList');
        }}
      >Patient List
      </NavbarBrand>
      <Nav className="ml-auto" navbar>
        <NavItem>
          <NavLink style={styles.logout} onClick={() => { logoutUser(); }}>Logout</NavLink>
        </NavItem>
      </Nav>
    </Navbar>
  </div>
);

export default PatientHomeNav;



// WEBPACK FOOTER //
// ./src/components/PatientHome/PatientHomeNav.js